import {Typography, ActionButton} from '@hconnect/uikit'
import {makeStyles} from '@material-ui/core'
import {Close, Check} from '@material-ui/icons'
import {Box, Grid, IconButton, Theme} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

export const useStyles = makeStyles((theme: Theme) => ({
  requestForQuotePersistencyBanner: {
    position: 'relative',
    background: '#D8F1F1',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 20px'
  },
  actionButtons: {
    display: 'flex',
    justifyContent: 'end',
    marginRight: '20px'
  },
  closeButton: {
    position: 'absolute',
    right: '10px',
    [theme.breakpoints.up('md')]: {
      top: '10px'
    },
    top: '6px'
  }
}))

export enum PersistedRequestForQuoteAction {
  CopyPreviousRequest = 'CopyPreviousRequest',
  NoAction = 'NoAction'
}

interface Props {
  onClose: (action: PersistedRequestForQuoteAction) => void
}

export const PersistedRequestForQuoteBanner: React.FC<Props> = ({onClose}) => {
  const {t} = useTranslation()
  const classes = useStyles()

  return (
    <Grid item xs={12} marginTop={3} data-test-id="persisted-rfq-banner">
      <Grid container className={classes.requestForQuotePersistencyBanner}>
        <Grid item xs={12} md={6} marginRight={2}>
          <Typography>{t('orderIntake.requestForQuote.persistency.reorder')}</Typography>
        </Grid>

        <Grid item xs={12} md={5}>
          <Box className={classes.actionButtons}>
            <ActionButton
              data-test-id="persisted-rfq-banner-yes-button"
              onClick={() => onClose(PersistedRequestForQuoteAction.CopyPreviousRequest)}
              style={{border: 'none', boxShadow: 'none'}}
              icon={<Check color="primary" />}
            >
              {t('orderIntake.requestForQuote.persistency.yes')}
            </ActionButton>
          </Box>
        </Grid>

        <Box className={classes.closeButton}>
          <IconButton
            data-test-id="persisted-rfq-banner-close-button"
            onClick={() => onClose(PersistedRequestForQuoteAction.NoAction)}
            style={{border: 'none', boxShadow: 'none'}}
          >
            <Close />
          </IconButton>
        </Box>
      </Grid>
    </Grid>
  )
}
